import { Box, Icon } from '@zillow/constellation-10';
import { IconLightBulbFilled } from '@zillow/constellation-icons';

const getAriaDescribedBy = (fieldName: string): string | undefined =>
  fieldName ? `learn-more-about-${fieldName}` : undefined;

interface RecommendationIconBulbProps {
  onClick: () => void;
  removeFlex?: boolean;
  fieldName?: string;
  dataEventid?: string;
}

const RecommendationIconBulb = ({
  onClick,
  removeFlex = false,
  fieldName = '',
  dataEventid = '',
}: RecommendationIconBulbProps) => {
  if (removeFlex) {
    return (
      <Icon
        data-eventid={dataEventid}
        aria-describedby={getAriaDescribedBy(fieldName)}
        aria-hidden={false}
        onClick={onClick}
        css={{ color: 'icon.accent.brand.hero', marginRight: '200', cursor: 'pointer' }}
        size="sm"
        render={<IconLightBulbFilled />}
      >
        <title id={getAriaDescribedBy(fieldName)}>Recommendation</title>
      </Icon>
    );
  }

  return (
    <Box css={{ display: 'flex' }}>
      <Icon
        data-eventid={dataEventid}
        aria-describedby={getAriaDescribedBy(fieldName)}
        aria-hidden={false}
        onClick={onClick}
        css={{
          color: 'icon.accent.brand.hero',
          marginRight: '200',
          marginLeft: { base: 0, lg: 'spacing.-100' },
          cursor: 'pointer',
        }}
        size="md"
        render={<IconLightBulbFilled />}
      >
        <title id={getAriaDescribedBy(fieldName)}>Recommendation</title>
      </Icon>
    </Box>
  );
};

export default RecommendationIconBulb;
